import { useState } from 'react';
import { Card, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import * as React from 'react';
import { FindLogByTicketId } from '../../hooks/processing/useProcessingLogs';
import { TicketLogEntry } from '../../interfaces/processing';
import { NullString } from '../../interfaces/general';
import ErrorMessage from '../shared/ErrorMessage';
import TicketLogRow from './TicketLogRow';
import { LoadingButton } from '@mui/lab';
import CustomerTicketRow from './customer/CustomerTicketRow';

interface SearchByTicketIdProps {
  getLogByTicketId: FindLogByTicketId;
  renderComponent: 'TicketLogRow' | 'CustomerTicketRow';
}

export default function SearchByTicketId({ getLogByTicketId, renderComponent }: SearchByTicketIdProps) {
  const [ticketIdInput, setTicketIdInput] = useState<string>('');
  const [foundLog, setFoundLog] = useState<TicketLogEntry | null>(null);
  const [searchError, setSearchError] = useState<NullString>(null);
  const [searching, setSearching] = useState<boolean>(false);

  function performSearch() {
    setSearchError(null);
    setSearching(true);
    getLogByTicketId(ticketIdInput)
      .then((res) => {
        console.log('found log:', res);
        if (res.success) {
          if (res.log) {
            setFoundLog(res.log);
          } else {
            setSearchError('No ticket found with that ID');
          }
        } else {
          setSearchError(res.error || 'An error occurred while searching for the ticket');
        }
      })
      .catch((err) => {
        setSearchError(err?.message || err?.detail || `${err}`);
      })
      .finally(() => {
        setSearching(false);
      });
  }

  return (
    <Card
      style={{
        padding: '10px',
        marginTop: '20px',
        marginBottom: '20px',
        maxWidth: '800px',
        boxShadow: '0px 0px 0px rgba(0, 0, 0, 0)'
      }}
    >
      <h4>Search by ticket ID</h4>

      <div style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>
        <TextField
          onChange={(e) => {
            setTicketIdInput(e.target.value);
          }}
          size="small"
          value={ticketIdInput}
          fullWidth
          name="first_name"
        />

        <LoadingButton
          onClick={() => {
            performSearch();
          }}
          startIcon={<SearchIcon />}
          variant="contained"
          loading={searching}
        >
          Search
        </LoadingButton>
      </div>

      {searchError && <ErrorMessage errorMsg={searchError} />}

      {foundLog &&
        (renderComponent === 'TicketLogRow' ? (
          <TicketLogRow ticketLogEntry={foundLog} />
        ) : (
          <CustomerTicketRow ticketLogEntry={foundLog} runs={[]} />
        ))}
    </Card>
  );
}
